import { Component, input, InputSignal, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { ReferralInputWithRevertComponent } from '../Input-With-Revert/referralInputWithRevert.component';
import { ReferralPageService } from '../referralPage.service';

@Component({
    selector: 'referral-value-assessments',
    templateUrl: 'valueAssessments.component.html',
    styleUrls: ['../referralPage.component.scss'],
    imports: [ReactiveFormsModule, ReferralInputWithRevertComponent],
})
export class ReferralValueAssessmentsComponent implements OnInit {
    constructor(private readonly _referralPageService: ReferralPageService) {}
    referral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    form: InputSignal<FormGroup> = input<FormGroup>();
    systemReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    originalReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    editMode = this._referralPageService.editMode;

    issuesOnAppealOptions: Weissman.Model.NameValuePair[];

    ngOnInit(): void {
        this.issuesOnAppealOptions = ['Valuation', 'Classification', 'Audit', 'Market', 'Equity', 'Other'].map((x) => ({
            name: x,
            value: x,
        }));
    }
}
